import { SmartAccountsSetupStep, SmartAccountsSetupStepConfig } from '~/types'

export const SMART_ACCOUNTS_SETUP_STEPS = {
  TEAM: {
    breadcrumbs: { label: 'Workspace', index: 0 },
    title: 'Welcome to Splits',
  },
  PROFILE: {
    breadcrumbs: { label: 'User', index: 1 },
    title: 'User profile',
  },
  OWNERS: {
    breadcrumbs: { label: 'Owners', index: 2 },
    title: 'Workspace owners',
  },
  TREASURY: {
    breadcrumbs: { label: 'Treasury', index: 3 },
    title: 'Treasury',
  },
  RECOVERY: {
    breadcrumbs: { label: 'Recovery', index: 4 },
    title: 'Recovery',
  },
  REVIEW: {
    breadcrumbs: { label: 'Review', index: 5 },
    title: 'Review',
  },
  COMPLETED: { breadcrumbs: undefined },
  SKIPPED: { breadcrumbs: undefined },
} as const satisfies Record<
  SmartAccountsSetupStep,
  SmartAccountsSetupStepConfig
>

export const SMART_ACCOUNTS_SETUP_STEPS_ORDER = Object.keys(
  SMART_ACCOUNTS_SETUP_STEPS,
) as SmartAccountsSetupStep[]
